/* eslint-disable no-use-before-define */

import { pushDataLayer } from "../../shared/helpers/gtm_tracking";

import style from "./freshchat.module.scss";

const BUTTON_ID = "freshchat-button";
const HOST = "https://wchat.freshchat.com";
const PAYLOAD = {
  event: "GAEvent",
  eventCategory: "All pages",
  eventAction: "Live Chat",
  eventLabel: "Clicked"
};

function openWidget() {
  const { fcWidget } = window;

  if (!fcWidget.isOpen()) {
    fcWidget.open();
  }
}

function onError() {
  const button = document.getElementById(BUTTON_ID);

  button.removeEventListener("click", onButtonClick);
  button.disabled = true;
  const { classList } = button.querySelector("i");

  classList.remove("fa-spin");
  classList.remove("fa-spinner");
  classList.add("fa-exclamation-triangle");
}

function onLoad() {
  const { fcWidget } = window;

  if (!fcWidget) {
    onError();

    return;
  }

  fcWidget.init({
    host: HOST,
    token: "a1c684c2-767d-4bf3-8aca-0996aaa78af8",
    config: {
      headerProperty: {
        direction: 'ltr',
        hideChatButton: true
      }
    }
  });
  fcWidget.on("widget:opened", () => {
    pushDataLayer(PAYLOAD);
    document.getElementById(BUTTON_ID).classList.remove(style["loading"]);
  });
  openWidget();
}

function onButtonClick(e) {
  const { target } = e;

  target.classList.add(style["loading"]);
  if (window.fcWidget) { // script is loaded
    openWidget();

    return;
  }

  // load script
  const script = document.createElement("script");

  script.addEventListener("load", onLoad);
  script.addEventListener("error", onError);
  script.src = `${HOST}/js/widget.js`;

  document.body.appendChild(script);
}

function freshchat() {
  const button = document.createElement("button");

  button.classList.add(style["freshchat-button"]);
  button.id = BUTTON_ID;
  button.type = "button";
  button.appendChild(document.createTextNode("Chat with us"));

  const i = document.createElement("i");

  i.className = "fa fa-spinner fa-spin";
  button.appendChild(i);

  button.addEventListener("click", onButtonClick);

  document.body.appendChild(button);
}

export default freshchat;
export {
  BUTTON_ID
};



// WEBPACK FOOTER //
// ./components/freshchat/freshchat.js